import { createFileRoute } from "@tanstack/react-router";
import React from "react";

export const Route = createFileRoute("/$lang/fatawa")({
  component: React.lazy(() => import("@/pages/fatawa").then((mod) => ({ default: mod.default }))),
});
